import {useState,useEffect} from 'react';import axios from 'axios';
const T={bg:'#f0f5e8',cream:'#fffef0',greenDk:'#1b5e20',maroon:'#6d1b1b',orange:'#e65100',border:'#c8e6c9',header:'linear-gradient(135deg,#090b72,#1a237e)'};
const MuhurthamsPage=()=>{const [data,setData]=useState([]);
useEffect(()=>{axios.get('/data/panchangam_data-2025-to-2028.json').then(r=>{
const now=new Date();now.setHours(0,0,0,0);
const filtered=r.data.filter(d=>{const p=d.EnglishDate.split('/');return new Date(parseInt(p[2]),parseInt(p[0])-1,parseInt(p[1]))>=now;}).slice(0,30);
setData(filtered);}).catch(()=>{});},[]);
return(<div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
<div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
<img src="/images/rituals/kalyana-uthsavam.jpg" alt="கல்யாண உத்ஸவம்" style={{height:'55px',borderRadius:'8px',marginBottom:'6px',border:'2px solid #f0d48a'}} />
<h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>🕐 முகூர்த்த நாட்கள்</h1>
<div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Muhurtham Days</div></div>

{/* Vivaha reference checklist */}
<div style={{textAlign:'center',marginBottom:'10px'}}>
  <img src="/images/rituals/vivaha-list1.jpg" alt="விவாஹ சுபதின பட்டியல்" style={{maxWidth:'100%',borderRadius:'8px',border:'2px solid '+T.border}} />
</div>

{data.map((d,i)=>(<div key={i} style={{background:T.cream,padding:'6px 8px',borderRadius:'4px',marginBottom:'2px',border:'1px solid '+T.border,fontSize:'0.7rem'}}>
<b style={{color:T.greenDk}}>{d.EnglishDate}</b> {d.DayNameInTamil} | {d.ThithiNameInTamil} | {d.NakshatraNameInTamil}
{d.DaySpecialityInTamil&&<span style={{color:T.orange}}> ✨{d.DaySpecialityInTamil}</span>}
</div>))}</div>);};
export default MuhurthamsPage;